import Image from "!url-loader!..\\..\\..\\..\\src\\images\\fotos\\suriname-900.jpg";
import * as React from 'react';
export default {
  Image,
  React
};